import React from "react";
import { NumberInput, SelectInput, RadioGroup } from "@/components/tools/Inputs";
import { US_STATES } from "@/lib/states";
import { BEST_TIME_OPTIONS, CONTACT_METHOD_OPTIONS } from "@/lib/applyForm";

const textInput =
  "w-full px-4 py-3 rounded-xl border border-lw-navy/15 bg-white font-sans-ui text-base text-lw-navy placeholder:text-lw-muted/60 focus:outline-none focus:ring-2 focus:ring-lw-gold/50 focus:border-lw-gold transition-all";

export const Step4 = ({ data, onChange, errors }) => {
  const set = (k) => (v) => onChange({ ...data, [k]: v });
  return (
    <div data-testid="apply-step-4" className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <label className="block sm:col-span-2">
          <span className="block font-sans-ui text-sm font-medium text-lw-navy mb-1.5">
            Full name
          </span>
          <input
            type="text"
            value={data.full_name}
            onChange={(e) => set("full_name")(e.target.value)}
            data-testid="apply-full-name"
            className={`${textInput} ${
              errors.full_name ? "border-red-400 focus:ring-red-300" : ""
            }`}
            placeholder="Jane Q. Smith"
          />
          {errors.full_name && (
            <span className="mt-1.5 block text-xs text-red-600">
              {errors.full_name}
            </span>
          )}
        </label>

        <label className="block">
          <span className="block font-sans-ui text-sm font-medium text-lw-navy mb-1.5">
            Email
          </span>
          <input
            type="email"
            value={data.email}
            onChange={(e) => set("email")(e.target.value)}
            data-testid="apply-email"
            className={`${textInput} ${
              errors.email ? "border-red-400 focus:ring-red-300" : ""
            }`}
            placeholder="jane@example.com"
          />
          {errors.email && (
            <span className="mt-1.5 block text-xs text-red-600">
              {errors.email}
            </span>
          )}
        </label>

        <label className="block">
          <span className="block font-sans-ui text-sm font-medium text-lw-navy mb-1.5">
            Phone
          </span>
          <input
            type="tel"
            value={data.phone}
            onChange={(e) => set("phone")(e.target.value)}
            data-testid="apply-phone"
            className={`${textInput} ${
              errors.phone ? "border-red-400 focus:ring-red-300" : ""
            }`}
            placeholder="(415) 555-0123"
          />
          {errors.phone && (
            <span className="mt-1.5 block text-xs text-red-600">
              {errors.phone}
            </span>
          )}
        </label>

        <SelectInput
          label="State"
          value={data.state}
          onChange={set("state")}
          options={[{ value: "", label: "Select…" }, ...US_STATES]}
          testId="apply-state"
          error={errors.state}
        />

        <SelectInput
          label="Best time to contact"
          value={data.best_time}
          onChange={set("best_time")}
          options={BEST_TIME_OPTIONS}
          testId="apply-best-time"
        />
      </div>

      <RadioGroup
        label="Preferred contact method"
        value={data.contact_method}
        onChange={set("contact_method")}
        options={CONTACT_METHOD_OPTIONS}
        testId="apply-contact-method"
      />

      <label className="block">
        <span className="block font-sans-ui text-sm font-medium text-lw-navy mb-1.5">
          Notes or questions (optional)
        </span>
        <textarea
          value={data.notes}
          onChange={(e) => set("notes")(e.target.value)}
          data-testid="apply-notes"
          rows={4}
          className={`${textInput} resize-y min-h-[88px]`}
          placeholder="Tell us anything that would help your advisor prepare…"
        />
      </label>

      <button
        type="button"
        onClick={() => set("consent")(!data.consent)}
        data-testid="apply-consent"
        className={`flex items-start gap-3 w-full px-4 py-4 rounded-xl border text-left transition-all ${
          data.consent
            ? "border-lw-gold bg-lw-gold/10"
            : "border-lw-navy/15 bg-white hover:border-lw-navy/30"
        } ${errors.consent ? "border-red-400" : ""}`}
      >
        <span
          aria-hidden="true"
          className={`mt-0.5 flex items-center justify-center w-5 h-5 rounded-md border flex-shrink-0 ${
            data.consent
              ? "bg-lw-gold border-lw-gold"
              : "border-lw-navy/30 bg-white"
          }`}
        >
          {data.consent && (
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path
                d="M2 6L5 9L10 3"
                stroke="#0B2545"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
        <span className="text-sm text-lw-navy/90 leading-relaxed">
          I consent that a licensed insurance producer may contact me by phone,
          email, or text at the information I provided regarding insurance
          products and services. Consent is not a condition of purchase.
        </span>
      </button>
      {errors.consent && (
        <span className="block text-xs text-red-600 -mt-3">
          {errors.consent}
        </span>
      )}
    </div>
  );
};

export default Step4;
